import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import { STUDENT_PAYMENTS_BY_STUDENT, STUDENT_PAYMENTS_PRINCIPAL } from '../constants/actionTypes'
import * as API from '../constants/api'

export const paymentsPrincipal = createAsyncThunk(
  STUDENT_PAYMENTS_PRINCIPAL,
  async (
    params: PayloadCreatorParams<`${typeof API.STUDENT_PAYMENTS_PRINCIPAL}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.paymentsPrincipal(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const paymentsByStudent = createAsyncThunk(
  STUDENT_PAYMENTS_BY_STUDENT,
  async (
    params: PayloadCreatorParams<`${typeof API.STUDENT_PAYMENTS_BY_STUDENT}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.paymentsByStudent(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const paymentsPrincipalClear = createAction(`${STUDENT_PAYMENTS_PRINCIPAL}/clear`)
